import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-overflow-x-auto tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur" }
const _hoisted_2 = { class: "tw-min-w-full tw-text-left tw-text-sm tw-text-slate-700 tw-border-separate tw-border-spacing-0" }
const _hoisted_3 = { class: "tw-bg-slate-50/70 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600" }
const _hoisted_4 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_5 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_6 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_7 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_8 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_9 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_10 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_11 = { class: "tw-inline-flex tw-items-center tw-gap-2" }
const _hoisted_12 = { class: "tw-divide-y tw-divide-slate-200/70" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DispatchTableRow = _resolveComponent("DispatchTableRow")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", _hoisted_3, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", {
              class: "tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateSortBy('containerId')))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "Container number", -1)),
                _createVNode(_component_font_awesome_icon, {
                  icon: _ctx.sortBy === 'containerId' && _ctx.sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down',
                  class: _normalizeClass(["tw-h-3 tw-w-3", _ctx.sortBy === 'containerId' ? 'tw-text-slate-900' : 'tw-text-slate-300'])
                }, null, 8, ["icon", "class"])
              ])
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Order Type", -1)),
            _cache[17] || (_cache[17] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Size/Type", -1)),
            _createElementVNode("th", {
              class: "tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateSortBy('bl')))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "BL/BKG", -1)),
                _createVNode(_component_font_awesome_icon, {
                  icon: _ctx.sortBy === 'bl' && _ctx.sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down',
                  class: _normalizeClass(["tw-h-3 tw-w-3", _ctx.sortBy === 'bl' ? 'tw-text-slate-900' : 'tw-text-slate-300'])
                }, null, 8, ["icon", "class"])
              ])
            ]),
            _createElementVNode("th", {
              class: "tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateSortBy('origin')))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _cache[10] || (_cache[10] = _createElementVNode("span", null, "Origin", -1)),
                _createVNode(_component_font_awesome_icon, {
                  icon: _ctx.sortBy === 'origin' && _ctx.sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down',
                  class: _normalizeClass(["tw-h-3 tw-w-3", _ctx.sortBy === 'origin' ? 'tw-text-slate-900' : 'tw-text-slate-300'])
                }, null, 8, ["icon", "class"])
              ])
            ]),
            _createElementVNode("th", {
              class: "tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateSortBy('destination')))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _cache[11] || (_cache[11] = _createElementVNode("span", null, "Destination", -1)),
                _createVNode(_component_font_awesome_icon, {
                  icon: _ctx.sortBy === 'destination' && _ctx.sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down',
                  class: _normalizeClass(["tw-h-3 tw-w-3", _ctx.sortBy === 'destination' ? 'tw-text-slate-900' : 'tw-text-slate-300'])
                }, null, 8, ["icon", "class"])
              ])
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Status", -1)),
            _createElementVNode("th", {
              class: "tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateSortBy('driver')))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _cache[12] || (_cache[12] = _createElementVNode("span", null, "Driver", -1)),
                _createVNode(_component_font_awesome_icon, {
                  icon: _ctx.sortBy === 'driver' && _ctx.sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down',
                  class: _normalizeClass(["tw-h-3 tw-w-3", _ctx.sortBy === 'driver' ? 'tw-text-slate-900' : 'tw-text-slate-300'])
                }, null, 8, ["icon", "class"])
              ])
            ]),
            _createElementVNode("th", {
              class: "tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateSortBy('chassis')))
            }, [
              _createElementVNode("div", _hoisted_9, [
                _cache[13] || (_cache[13] = _createElementVNode("span", null, "Chassis", -1)),
                _createVNode(_component_font_awesome_icon, {
                  icon: _ctx.sortBy === 'chassis' && _ctx.sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down',
                  class: _normalizeClass(["tw-h-3 tw-w-3", _ctx.sortBy === 'chassis' ? 'tw-text-slate-900' : 'tw-text-slate-300'])
                }, null, 8, ["icon", "class"])
              ])
            ]),
            _createElementVNode("th", {
              class: "tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateSortBy('customer')))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _cache[14] || (_cache[14] = _createElementVNode("span", null, "Customer", -1)),
                _createVNode(_component_font_awesome_icon, {
                  icon: _ctx.sortBy === 'customer' && _ctx.sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down',
                  class: _normalizeClass(["tw-h-3 tw-w-3", _ctx.sortBy === 'customer' ? 'tw-text-slate-900' : 'tw-text-slate-300'])
                }, null, 8, ["icon", "class"])
              ])
            ]),
            _createElementVNode("th", {
              class: "tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateSortBy('receiver')))
            }, [
              _createElementVNode("div", _hoisted_11, [
                _cache[15] || (_cache[15] = _createElementVNode("span", null, "Receiver", -1)),
                _createVNode(_component_font_awesome_icon, {
                  icon: _ctx.sortBy === 'receiver' && _ctx.sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down',
                  class: _normalizeClass(["tw-h-3 tw-w-3", _ctx.sortBy === 'receiver' ? 'tw-text-slate-900' : 'tw-text-slate-300'])
                }, null, 8, ["icon", "class"])
              ])
            ])
          ])
        ]),
        _createElementVNode("tbody", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.containers, (container, containerIdx) => {
            return (_openBlock(), _createBlock(_component_DispatchTableRow, {
              container: container,
              key: container.id || containerIdx,
              onToggleTripStatus: _ctx.toggleTripStatus
            }, null, 8, ["container", "onToggleTripStatus"]))
          }), 128))
        ])
      ])
    ])
  ]))
}